import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { multilanguage } from "redux-multilanguage";
import { withRouter } from 'react-router-dom';
import { showToast } from "../../../state/ducks/utils/operations";

import useWindowDimension from "../../../hooks/useWindowDimension";
import CustomButton from '../../../components/UI/CustomButton/CustomButton';

import './UserConformation.scss';
import StorageService from "../../../services/localstorage.service";
import Scrollbars from 'react-custom-scrollbars';
import MetaTags from 'react-meta-tags';
import {
  getUserCurrentSubs,
  updateSubscription,
  login,
  initializeSession,
  authenticated,
  getProductPriceDetails,
  getSubscription,
  addPaymentMethod
} from '../../../state/ducks/auth/operations'
import Constant from '../../../util/constant';
import Label from '../../../components/UI/Label/Label';


function UserConformation(props) {
  let { strings } = props;
  const dimensions = useWindowDimension()
  const [busy, setBusy] = useState(false)
  const [subscription, setSubscription] = useState([])
  const [priceDetails, setPriceDetails] = useState(null)

  const redirect = async () => { }

  useEffect(()=>{
    if(!StorageService.getItem("user")){
      props.history.push("/", {
        redirectFrom: props.location?.pathname,
      });
    }
  }, [])


  useEffect(() => {
    if (props.location.state?.stipeId) {
      props.getUserCurrentSubs({
        id: props.location.state?.stipeId
      }).then((res) => {
        console.log(res.payload);
        setSubscription(res.payload[0])
      }).catch((err) => {
        console.log(err);
      })
      loginUser()
    }
    if (props.location.state?.productId) {
      props.getProductPriceDetails({
        id: props.location.state?.productId
      }).then((res) => {
        console.log(res.payload);
        setPriceDetails(res.payload)
      }).catch((err) => {
        console.log(err);
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loginUser = async () => {
    let params = {
      email: props.location.state?.email.toLowerCase(),
      password: props.location.state?.password,
    };
    await props
      .login(params)
      .then((response) => {
        if (response) {
          const { payload, message } = response;
          const { user, tokens } = payload;
          setTimeout(() => {
            props.initializeSession({ user, tokens });
            props.authenticated();
          }, 2000);
        }
      })
      .catch((err) => {
      });
  }


  const completeScheduledProcess = async () => {
    setBusy(true)
    const data = {
      cus_id: props.location.state?.stipeId,
      sub_id: subscription.id,
      user_id: props.location.state?.user_id,
      productId: props.location.state?.productId,
      unit_amount: priceDetails.unit_amount
    }
    await props.updateSubscription(data).then((res) => {
      console.log(res);
      setTimeout(() => {
        setBusy(false)
        props.history.push('/Home', {
          redirectFrom: 'UserConfirmation'
        })
      }, 2000);
    }).catch((error) => {
      setBusy(false)
      console.log(error);
    })
  }

  const convertIntoPrice = (price) => {
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'EUR',
    });
    return formatter.format(price);    
  }


  return (
    <div className="userConformationPage">
      <MetaTags>
        <title>Safer Walking | Connect & Manage Your GPS Locator</title>
        <meta name="description" content="Buy a new Safer Walking device and register your account to manage your devices on the go. Contact our team to find out more." />
        <meta property="og:title" content="Safer Walking | Connect & Manage Your GPS Locator" />
        <meta property="og:description" content="Buy a new Safer Walking device and register your account to manage your devices on the go. Contact our team to find out more." />
        <meta property="og:image" content="https://res.cloudinary.com/ravencourt-ltd/image/upload/v1661425601/Safer-Walking/Web-App/Project-images/efd6a92fbc2a1923d45825d3e859162b_irzily.png" />
      </MetaTags>
      <Scrollbars className="formMain" style={{ height: dimensions.height }}>
        <div className="logo">
          <img src={Constant.IMAGESURL.LOGO} title="" alt="" />
        </div>
        <div className="formCenter">
          <Label title='Subscription Details' />
          <div className='card-container'>
            <div className='card-inner-container'>
              <div className="cart_add_device">
                <div className='subtitle'><i className="icon-cart"></i>Current Plan</div>
                <div className='containRow'>
                  {/* <div className="device_name">{subscription?.object}</div> */}
                  <div className="number_txt"><span className='price-amount'>{subscription?.plan?.amount && convertIntoPrice(parseInt(subscription?.plan?.amount)/100)}</span><div className="amount">{subscription?.plan?.interval && ` /${subscription?.plan?.interval}`}</div></div>
                </div>
              </div>

              <div className="cart_add_device">
                <div className='subtitle'><i className="icon-cart"></i>New Plan</div>
                <div className='containRow'>
                  {console.log('priceDetails', priceDetails)}
                  {/* <div className="device_name">{subscription?.object}</div> */}
                  {priceDetails != null && <div className="number_txt"><span className='price-amount'>{convertIntoPrice(parseInt(priceDetails.unit_amount)/100)}</span><div className="amount"> /{priceDetails.recurring.interval}</div></div>}
                </div>

              </div>
              <div className='content-box'>
                <p className='content'>
                On the next screen, you will be asked to enter some details about your device including the IMEI number and its telephone number. 
                If you have trouble finding these details, or any questions about the process please contact our support team on <a href='tel:01780489100'>01780489100</a>.
                </p>
              </div>
              <div className="custombtnfield">
                <CustomButton onClick={() => {
                  completeScheduledProcess()
                }} type="submit" title={`Confirm`} disabled={!props.location.state?.stipeId} loading={busy} />
              </div>
            </div>
          </div>
        </div>
      </Scrollbars>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
  }
};

const mapDispatchToProps = {
  showToast, getUserCurrentSubs, updateSubscription, login,
  initializeSession,
  authenticated,
  getProductPriceDetails,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(multilanguage(UserConformation)));
